import { Injectable } from '@angular/core';
import { Scheme } from 'app/system/app.config';

const STORAGE_PREFIX = 'app-scheme:';

@Injectable({
    providedIn: 'root',
})
export class SchemePreferenceService {
    private _storageKey(): string {
        if (typeof window === 'undefined') {
            return `${STORAGE_PREFIX}default`;
        }
        return `${STORAGE_PREFIX}${(window.location.hostname || 'default').toLowerCase()}`;
    }

    get(): Scheme | null {
        if (typeof localStorage === 'undefined') {
            return null;
        }

        try {
            const raw = localStorage.getItem(this._storageKey());
            if (raw === 'light' || raw === 'dark') {
                return raw;
            }
        } catch {
            return null;
        }

        return null;
    }

    set(scheme: 'light' | 'dark'): void {
        if (typeof localStorage === 'undefined') {
            return;
        }

        try {
            localStorage.setItem(this._storageKey(), scheme);
        } catch {
            // Ignore quota / private mode errors.
        }
    }
}
